import { AbsoluteRoute } from "../../../core/routes";
import { type LensSubmissionFlowState } from "../../models";

export const getFlowSubmissionState = (route: string): LensSubmissionFlowState => {
    const routes: string[] = [AbsoluteRoute.CREATE_ORG_LENS_FOLDER, AbsoluteRoute.SUBMIT_LENS_FOLDER_CREATE];
    if (routes.includes(route)) {
        return { useDefaultNames: true };
    }
    return { useDefaultNames: false };
};
